// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.revenue-dashboard {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  background: linear-gradient(135deg, #f8fafc 0%, #e0f2fe 50%, #e0e7ff 100%);
  min-height: 100vh;
  padding: 24px;
}

/* Card Components */
.custom-card {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.custom-card:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: translateY(-4px);
}

.custom-card-header {
  padding: 24px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(to right, #f8fafc, white);
}

.custom-card-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.custom-card-content {
  padding: 24px;
}

/* Header Styles */
.dashboard-header {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  padding: 24px;
  margin-bottom: 24px;
}

.gradient-text {
  background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 4px;
}

/* Button Styles */
.btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  font-size: 14px;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background: #2563eb;
  color: white;
}

.btn-primary:hover {
  background: #1d4ed8;
}

.btn-success {
  background: #059669;
  color: white;
}

.btn-success:hover {
  background: #047857;
}

.btn-secondary {
  background: white;
  color: #2563eb;
  border: 1px solid #e2e8f0;
}

.btn-secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

/* Grid Layouts */
.grid {
  display: grid;
  gap: 24px;
}

.grid-cols-1 {
  grid-template-columns: 1fr;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}
.grid-cols-3 {
  grid-template-columns: repeat(3, 1fr);
}
.grid-cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

/* Filter Bar */
.filter-bar {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-bottom: 24px;
}

.filter-item {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  color: #475569;
  display: flex;
  align-items: center;
  white-space: nowrap;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.filter-item:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

/* Icon Containers */
.icon-container {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.icon-sm {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  margin-right: 12px;
}

/* Data Cards */
.data-grid {
  display: grid;
  gap: 12px;
  margin: 16px 0;
}

.data-item {
  background: #f8fafc;
  border-radius: 8px;
  padding: 12px;
}

.data-label {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.data-value {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.data-value-lg {
  font-size: 24px;
  font-weight: 700;
}

/* Revenue Highlight */
.revenue-highlight {
  background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%);
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 16px;
  margin: 16px 0;
}

.revenue-success {
  background: linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%);
  border: 1px solid #bbf7d0;
}

/* Status Indicators */
.growth-badge {
  display: inline-flex;
  align-items: center;
  background: #dcfce7;
  color: #166534;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

.efficiency-badge {
  display: inline-flex;
  align-items: center;
  background: #dbeafe;
  color: #1e40af;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

/* Utility Classes */
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.mb-2 {
  margin-bottom: 8px;
}
.mb-4 {
  margin-bottom: 16px;
}
.mb-6 {
  margin-bottom: 24px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-4 {
  margin-top: 16px;
}
.mr-2 {
  margin-right: 8px;
}
.mr-3 {
  margin-right: 12px;
}
.mr-4 {
  margin-right: 16px;
}
.space-y-4 > * + * {
  margin-top: 16px;
}

.text-sm {
  font-size: 14px;
}
.text-lg {
  font-size: 18px;
}
.text-xl {
  font-size: 20px;
}
.text-2xl {
  font-size: 24px;
}
.text-3xl {
  font-size: 30px;
}

.font-semibold {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}

.text-slate-600 {
  color: #475569;
}
.text-slate-700 {
  color: #334155;
}
.text-slate-800 {
  color: #1e293b;
}
.text-blue-600 {
  color: #2563eb;
}
.text-green-600 {
  color: #059669;
}
.text-white {
  color: white;
}

.bg-blue-50 {
  background-color: #dbeafe;
}
.bg-blue-100 {
  background-color: #dbeafe;
}
.bg-green-50 {
  background-color: #dcfce7;
}
.bg-purple-100 {
  background-color: #e9d5ff;
}

.border-slate-200 {
  border-color: #e2e8f0;
}
.border-blue-100 {
  border-color: #dbeafe;
}
.border-purple-200 {
  border-color: #ddd6fe;
}

.rounded-lg {
  border-radius: 8px;
}
.rounded-xl {
  border-radius: 12px;
}
.rounded-2xl {
  border-radius: 16px;
}

.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.cursor-pointer {
  cursor: pointer;
}

/* Responsive Design */
@media (max-width: 768px) {
  .revenue-dashboard {
    padding: 16px;
  }

  .grid-cols-4,
  .grid-cols-3 {
    grid-template-columns: repeat(2, 1fr);
  }

  .dashboard-header {
    padding: 16px;
  }

  .gradient-text {
    font-size: 24px;
  }
}

@media (max-width: 640px) {
  .grid-cols-4,
  .grid-cols-3,
  .grid-cols-2 {
    grid-template-columns: 1fr;
  }

  .filter-bar {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/styles.css"],"names":[],"mappings":"AAAA;EACE,mEAAmE;EACnE,0EAA0E;EAC1E,iBAAiB;EACjB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE;wCACsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".revenue-dashboard {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, sans-serif;\n  background: linear-gradient(135deg, #f8fafc 0%, #e0f2fe 50%, #e0e7ff 100%);\n  min-height: 100vh;\n  padding: 24px;\n}\n\n/* Card Components */\n.custom-card {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.custom-card:hover {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  transform: translateY(-4px);\n}\n\n.custom-card-header {\n  padding: 24px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(to right, #f8fafc, white);\n}\n\n.custom-card-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n}\n\n.custom-card-content {\n  padding: 24px;\n}\n\n/* Header Styles */\n.dashboard-header {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n/* Button Styles */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 12px 20px;\n  border-radius: 12px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.btn-primary {\n  background: #2563eb;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #1d4ed8;\n}\n\n.btn-success {\n  background: #059669;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #047857;\n}\n\n.btn-secondary {\n  background: white;\n  color: #2563eb;\n  border: 1px solid #e2e8f0;\n}\n\n.btn-secondary:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n/* Grid Layouts */\n.grid {\n  display: grid;\n  gap: 24px;\n}\n\n.grid-cols-1 {\n  grid-template-columns: 1fr;\n}\n.grid-cols-2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n.grid-cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n.grid-cols-4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* Filter Bar */\n.filter-bar {\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n  margin-bottom: 24px;\n}\n\n.filter-item {\n  background: white;\n  border: 1px solid #e2e8f0;\n  padding: 12px 16px;\n  border-radius: 12px;\n  font-size: 14px;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.filter-item:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n/* Icon Containers */\n.icon-container {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 16px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.icon-sm {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  margin-right: 12px;\n}\n\n/* Data Cards */\n.data-grid {\n  display: grid;\n  gap: 12px;\n  margin: 16px 0;\n}\n\n.data-item {\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.data-label {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.data-value {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.data-value-lg {\n  font-size: 24px;\n  font-weight: 700;\n}\n\n/* Revenue Highlight */\n.revenue-highlight {\n  background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%);\n  border: 1px solid #bfdbfe;\n  border-radius: 12px;\n  padding: 16px;\n  margin: 16px 0;\n}\n\n.revenue-success {\n  background: linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%);\n  border: 1px solid #bbf7d0;\n}\n\n/* Status Indicators */\n.growth-badge {\n  display: inline-flex;\n  align-items: center;\n  background: #dcfce7;\n  color: #166534;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.efficiency-badge {\n  display: inline-flex;\n  align-items: center;\n  background: #dbeafe;\n  color: #1e40af;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Utility Classes */\n.flex {\n  display: flex;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.mb-2 {\n  margin-bottom: 8px;\n}\n.mb-4 {\n  margin-bottom: 16px;\n}\n.mb-6 {\n  margin-bottom: 24px;\n}\n.mt-2 {\n  margin-top: 8px;\n}\n.mt-4 {\n  margin-top: 16px;\n}\n.mr-2 {\n  margin-right: 8px;\n}\n.mr-3 {\n  margin-right: 12px;\n}\n.mr-4 {\n  margin-right: 16px;\n}\n.space-y-4 > * + * {\n  margin-top: 16px;\n}\n\n.text-sm {\n  font-size: 14px;\n}\n.text-lg {\n  font-size: 18px;\n}\n.text-xl {\n  font-size: 20px;\n}\n.text-2xl {\n  font-size: 24px;\n}\n.text-3xl {\n  font-size: 30px;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n.font-bold {\n  font-weight: 700;\n}\n\n.text-slate-600 {\n  color: #475569;\n}\n.text-slate-700 {\n  color: #334155;\n}\n.text-slate-800 {\n  color: #1e293b;\n}\n.text-blue-600 {\n  color: #2563eb;\n}\n.text-green-600 {\n  color: #059669;\n}\n.text-white {\n  color: white;\n}\n\n.bg-blue-50 {\n  background-color: #dbeafe;\n}\n.bg-blue-100 {\n  background-color: #dbeafe;\n}\n.bg-green-50 {\n  background-color: #dcfce7;\n}\n.bg-purple-100 {\n  background-color: #e9d5ff;\n}\n\n.border-slate-200 {\n  border-color: #e2e8f0;\n}\n.border-blue-100 {\n  border-color: #dbeafe;\n}\n.border-purple-200 {\n  border-color: #ddd6fe;\n}\n\n.rounded-lg {\n  border-radius: 8px;\n}\n.rounded-xl {\n  border-radius: 12px;\n}\n.rounded-2xl {\n  border-radius: 16px;\n}\n\n.shadow-sm {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n.shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .revenue-dashboard {\n    padding: 16px;\n  }\n\n  .grid-cols-4,\n  .grid-cols-3 {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .dashboard-header {\n    padding: 16px;\n  }\n\n  .gradient-text {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 640px) {\n  .grid-cols-4,\n  .grid-cols-3,\n  .grid-cols-2 {\n    grid-template-columns: 1fr;\n  }\n\n  .filter-bar {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
